'use strict';exports.__esModule = true;var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatDate = function formatDate(dateString, translate) {
  if (!dateString) {
    return null;
  }

  var fullDay = 86400000; // 24 hours
  var date = (0, _moment2.default)(dateString);
  var today = (0, _moment2.default)().startOf('day');
  var yesterday = (0, _moment2.default)(today - fullDay);

  if (date.isSame(today, 'd')) {
    return translate('propertyDetails', 'today');
  } else if (date.isSame(yesterday, 'd')) {
    return translate('propertyDetails', 'yesterday');
  }

  return date.format('DD/MM/YYYY');
};exports.default =

formatDate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatDate.js
// module id = 3135
// module chunks = 0